import React from "react"
import styled from "styled-components"
import IntercomWithAuth from "../Intercom/index.js"
import RaygunUser from "../Raygun/index.js"
import Routes from "./Routes.js"
import { AnalyticsWrapper as Analytics } from "../lib/Analytics/index.js"
import { withFeatureFlagProvider } from "../lib/feature-flags"
import ImpersonationOverlay from "../components/ImpersonationOverlay"
import { ModalProvider } from "../components/Dashboard/JobSeekerDashboard/ModalContext"
import { SegmentWrapper as SegmentAnalytics } from "../lib/Segment/"
import { withAuthProvider } from "../lib/auth"
import { TerminationStatusProvider } from "../components/Terminated/TerminationStatusContext"

const AuthedTerminationStatusProvider = withAuthProvider(
  TerminationStatusProvider,
)
export const MainBox = styled.main`
  height: 80vh;
`

export const App = () => (
  <MainBox>
    <ModalProvider>
      <AuthedTerminationStatusProvider>
        <ImpersonationOverlay />
        <RaygunUser />
        <Analytics />
        <SegmentAnalytics />
        <Routes />
        <IntercomWithAuth />
      </AuthedTerminationStatusProvider>
    </ModalProvider>
  </MainBox>
)

export default withFeatureFlagProvider(App)
